import * as Yup from 'yup';

export const formData = {
  email: '',
  password: '',
};

export const createErrorObject = (errors) => {
  let formErrors = {};
  formErrors.email = errors.email ? 'email' : '';
  formErrors.password = errors.password ? 'password' : '';
};

const createValidationSchema = (t) => Yup.object().shape({
  email: Yup.string()
    .email(t('formulary.validation.email_invalid'))
    .required(t('formulary.validation.email_required')),
  password: Yup.string().required(t('formulary.validation.password_required')),
});

// Export a function that returns the validation schema with translations
export const validationSchema = (t) => createValidationSchema(t);
